import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppResponseBase } from '../../shared-module/models/app-response-base';

@Injectable({
  providedIn: 'root'
})
export class FileTemplatesService {

  private apiUrl = `${environment.apiUrlBase}/api/file-templates`;

  constructor(
    private http: HttpClient
  ) { }

  downloadTemplate(templateName: string, data?: any): Observable<AppResponseBase<string>> {
    let url = `${this.apiUrl}/download-template/${templateName}`;
    return this.http.post<AppResponseBase<string>>(url, data);
  }

  getChatBotFileUrl(): Observable<AppResponseBase<string>> {
    let url = `${this.apiUrl}/chat-bot-file-url`;
    return this.http.get<AppResponseBase<string>>(url);
  }

}
